import { combineReducers } from 'redux'
import * as TypeAction from './actionTypes'
import { reducerCrud, reducerList } from 'scorpion-core';

export default combineReducers({
    auth: reducerCrud(TypeAction.SIGNIN),
    signup: reducerCrud(TypeAction.SIGNUP),
})


// WEBPACK FOOTER //
// ./src/routes/public/Login/reducer.js